import React from "react";
import useMetaTags from "../../hooks/useMetaTags"; // Adjust path based on your project structure

const MenstrualAllergiesOrganicSolutions = () => {
  useMetaTags({
    title: "Menstrual Allergies: The Organic Solution to Sensitive Period Care",
    description: "Struggling with allergies to menstrual products? Discover how hypoallergenic organic pads can help prevent irritation and provide comfort during your period.",
    keywords: "menstrual allergies, hypoallergenic pads, sensitive skin period care, organic menstrual products, fragrance-free pads",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/menstrual-allergies-organic-solutions",
    ogTitle: "Menstrual Allergies: The Organic Solution to Sensitive Period Care",
    ogDescription: "Conventional menstrual products can trigger allergies. Learn how organic, fragrance-free, and dye-free alternatives provide relief for sensitive skin.",
    ogImage: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600",
    ogUrl: "https://organicpads.shop/menstrual-allergies-organic-solutions",
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: "Menstrual Allergies: The Organic Solution to Sensitive Period Care",
    twitterDescription: "Reduce the risk of allergic reactions with hypoallergenic organic pads. Discover the benefits of fragrance-free, dye-free, and natural menstrual care.",
    twitterImage: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });

  const schemaMarkup  = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "/menstrual-allergies-organic-solutions"
    },
    "headline": "Menstrual Allergies: The Organic Solution to Sensitive Period Care",
    "description": "Struggling with allergies to menstrual products? Discover how hypoallergenic organic pads can help prevent irritation and provide comfort during your period.",
    "image": "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600",
    "author": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png"
      }
    },
    "datePublished": "2025-02-24",
    "dateModified": "2025-02-24",
    "keywords": [
      "menstrual allergies",
      "hypoallergenic pads",
      "sensitive skin period care",
      "organic menstrual products",
      "fragrance-free pads"
    ]
  }
  

  return (
    <>
    <div className="max-w-4xl mx-auto p-6 text-gray-800">
      <h1 className="text-3xl font-bold text-center text-green-600 mb-4">
        Dealing with Allergies: The Organic Solution to Menstrual Sensitivities
      </h1>
      <img
        src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600"
        alt="Allergy Solutions"
        className="w-full rounded-lg mb-4"
      />
      <p className="text-lg">
        Allergies to conventional menstrual products are more common than you think.
        Organic pads offer a hypoallergenic alternative that can help prevent and
        relieve allergic reactions during your period.
      </p>
      
      <h2 className="text-2xl font-semibold mt-6">Allergy-Friendly Benefits</h2>
      <ul className="list-disc pl-6 mt-2 space-y-2">
        <li>Hypoallergenic materials</li>
        <li>No artificial fragrances</li>
        <li>Dye-free construction</li>
        <li>Natural fiber comfort</li>
        <li>Reduced reaction risk</li>
      </ul>
      
      <h2 className="text-2xl font-semibold mt-6">How to Manage Allergies?</h2>
      <p className="mt-2">
        Select <strong>hypoallergenic certified</strong> organic pads and perform patch
        tests when trying new products.
      </p>
      
      <img
        src="https://plus.unsplash.com/premium-photo-1702598576513-fe7425ebf6bd?w=600"
        alt="Allergy Care"
        className="w-full rounded-lg mt-4"
      />
      
      <h2 className="text-2xl font-semibold mt-6 text-green-600">Final Thoughts</h2>
      <p className="mt-2 font-medium">
        Don't let allergies control your period. <strong>Choose organic for sensitive care!</strong>
      </p>
    </div>
     {/* Schema Markup */}
     <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};

export default MenstrualAllergiesOrganicSolutions;
